export default {
  forms: state => state.forms,
  form: state => state.form,
  steps: state => state.steps,
  fields: state => state.fields,
  fieldTypes: state => state.fieldTypes,
  fieldTypesGrouped: state => state.fieldTypesGrouped,
  selectedField: state => state.selectedField,
  selectedStep: state => state.selectedStep,
  isDirty: state => state.isDirty,
  isLoading: state => state.isLoading,

  // Get fields by step
  fieldsByStep: state => stepId => {
    return state.fields
      .filter(f => f.step_id === stepId)
      .sort((a, b) => a.order - b.order)
  },

  // Get fields without step (root level)
  rootFields: state => {
    return state.fields
      .filter(f => !f.step_id)
      .sort((a, b) => a.order - b.order)
  },

  // Get sorted steps
  sortedSteps: state => {
    return [...state.steps].sort((a, b) => a.order - b.order)
  },

  // Get field type by id
  fieldTypeById: state => id => {
    return state.fieldTypes.find(ft => ft.id === id)
  },

  // Get field type by name
  fieldTypeByName: state => name => {
    return state.fieldTypes.find(ft => ft.name === name)
  }
}
